export default "__VITE_ASSET__BFpKvcBs__"